import wrlog from "./helper/functions/wrlog";

wrlog("ENV", process.env)

export const BASENAME = '';
export const MAINTENANCE = process.env.REACT_APP_MAINTENANCE === 'true';
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;